module.exports = __webpack_public_path__ + "img/arrow-down.47fb15ce.svg";